import InfoList from './infoList';

export default InfoList;
